import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const MainSectionWrapper = styled('div', { label: 'MainSectionWrapper' })``;;

export const ChevronStyle = withConfig(theme => styled(ChevronIcon, { label: 'ChevronStyle' })`
    fill: ${theme.star.headings.section.txtColor};
    height: 100%;
    margin: 0 4px 0 8px;
    width: 16px;
`);

type SectionHeaderWrapperType = {
    isOpen: boolean;
}

export const SectionHeaderWrapper = withConfig(theme => styled('div', { label: 'SectionHeaderWrapper' })<SectionHeaderWrapperType>`
    align-items: center;
    background-color: ${theme.star.headings.section.bgColor};
    cursor: pointer;
    display: flex;
    padding: 8px 0;
    position: relative;
    &::after {
        border-top: 1px solid ${theme.star.headings.section.borderColor};
        bottom: 0;
        content: '';
        opacity: ${({ isOpen }):string => isOpen ? '0' : '1'};
        position: absolute;
        transition: opacity .2s ease;
        width: 100%;
    }
`);

export const TitleStyle = withConfig(theme => styled('h2', { label: 'TitleStyle' })`
    color: ${theme.star.headings.section.txtColor};
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.5;
    margin: 0;
    text-transform: uppercase;
    user-select: none;
`);
